export class ResultChartsModel {
    uploadedChart: any = {};
    semWiseUploadedChart: any = {};
    kTChart: any = {};
    semWiseKtChart: any = {};
    scoreChart: any = {};
    semWiseScoreChart: any = {};
    // selectedScore: any = {};
    // selectedKT: any = {};
    // selectedSem: any =
}